import React from 'react'
import './banner.css'
const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];

const Theme4NoPhotoBanner = ({values}) => {

    const isLargeNameFont = LARGE_NAME_FONTS.includes(
  values?.nameFontStyle
); 


    const noPhotoGroomNameDisplay = () => {
    return (
      <h3
        className={`t4-preview-banner-name ${
        isLargeNameFont ? "t4-preview-banner-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
          {values.groomName || "Groom"}
      </h3>
    );
  };

   const noPhotoBrideNameDisplay = () => {
    return (
      <h3
         className={`t4-preview-banner-name ${
        isLargeNameFont ? "t4-preview-banner-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
        {values.brideName || "Bride"}
      </h3>
    );
  };

  return (
  <>
           <picture>
  {/* Desktop */}
  <source
    media="(min-width: 768px)"
    srcSet={`
      https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1788689435/aamantran%20assets/theme-4-desktop-frame_okhshe.png 1080w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_1920/v1788689435/aamantran%20assets/theme-4-desktop-frame_okhshe.png 1920w
    `}
    sizes="100vw"
  />
  {/* Mobile */}
  <img
    src="https://res.cloudinary.com/depixc8dq/image/upload/v1788689434/aamantran%20assets/theme-4-cover-frame_oiijac.png"
    srcSet={`
      https://res.cloudinary.com/depixc8dq/image/upload/w_320/v1788689434/aamantran%20assets/theme-4-cover-frame_oiijac.png 320w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_640/v1788689434/aamantran%20assets/theme-4-cover-frame_oiijac.png 640w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1788689434/aamantran%20assets/theme-4-cover-frame_oiijac.png 1080w
    `}
    sizes="100vw"
    className="theme-4-preview-cover-frame"
    alt="cover background"
  />
</picture>
 <div className="t4-preview-cover-details">
 <span className="t4-preview-no-photo-cover-content">
          We are honored to welcome you to the wedding ceremony of
        </span>
        <div className="t4-preview-cover-name-wrapper">
           {values.displayOrder==="groomFirst"?(
          <>
               {noPhotoGroomNameDisplay()}
                <span 
                  className={`t4-preview-banner-and ${
        isLargeNameFont ? "t4-preview-banner-and--compact" : ""
      }`}
                 style={{ fontFamily: values.nameFontStyle }}>&</span>
                   {noPhotoBrideNameDisplay()}

          </>
         ):<>
    {noPhotoBrideNameDisplay()}
                <span 
                          className={`t4-preview-banner-and ${
        isLargeNameFont ? "t4-preview-banner-and--compact" : ""
      }`}
                style={{ fontFamily: values.nameFontStyle }}>&</span>
                  {noPhotoGroomNameDisplay()}
         </>}
 </div>
     <div className="t4-preview-banner-hashtag">  
             {values.hashtag ? `#${values.hashtag}` : ""}
           </div>
 </div>

  </>
  )
}

export default Theme4NoPhotoBanner